// extracted by mini-css-extract-plugin
export default {"cta":"TG-z","disabled":"UG-z"};